export const zogesInfo = {
  services: [
    {
      name: "Cultivation",
      pic: "",
      summary:
        "At Zoges Agro, our fields are a vibrant tapestry of diverse crops cultivated to perfection. From hearty grains to crisp vegetables and succulent fruits, our crop variety is a testament to the rich agricultural heritage of Zoges.",
    },
    {
      name: "Animal Rearing",
      pic: "",
      summary:
        "Delve into the heart of Zoges Agro's animal kingdom, where our livestock flourishes in natural surroundings. Our farm is home to a range of animals, from free-ranging poultry to contented cows. Explore the diversity that defines our livestock and sets the stage for quality meat and dairy production",
    },
    {
      name: "Trucking and Warehousing",
      pic: "",
      summary:
        " Zoges Agro and Trucking Ventures seamlessly bridges the gap between our farm and your destination. Our dedicated trucking division ensures the safe and efficient transportation of our farm produce. Count on us for reliable logistics that keep your orders on the move.",
    },
  ],
  contact: {
    email: "info@zogesagrotrucking.com",
    address: "AS 20 Benin Street Kaduna",
    phone: "+234 706 119 2613",
  },
  mainservice: [
    {
      name: "Cultivation Services",
      photos:
        "https://onedrive.live.com/embed?resid=B8295C03D418D49B%21840&authkey=%21AE67XS5Pu1lkSMs&width=612&height=408",
      subservice: [
        {
          name: "Crop Variety",
          detail:
            "At Zoges Agro, our fields are a vibrant tapestry of diverse crops cultivated to perfection. From hearty grains to crisp vegetables and  succulent fruits, our crop variety is a testament to the rich agricultural heritage of Zoges.",
        },
        {
          name: "Sustainable Practices",
          detail:
            " Zoges Agro takes pride in employing eco-friendly and sustainable farming methods. Our commitment to responsible land stewardship includes practices such as organic fertilization, water conservation,  and biodiversity preservation. We strive to cultivate in harmony with  nature, ensuring a greener and healthier future for all.",
        },
        {
          name: "Seasonal Offerings",
          detail:
            " Experience the changing seasons with Zoges Agro's seasonal offerings.  From the first blossoms of spring to the hearty harvests of autumn, our farm showcases a rotation of seasonal crops. Check our updates to discover the latest seasonal delights and their availability.",
        },
      ],
    },
    {
      name: "Animal Rearing Services",
      photos:
        "https://onedrive.live.com/embed?resid=B8295C03D418D49B%21844&authkey=%21AHgbejMKb2oZDXI&width=259&height=194",
      subservice: [
        {
          name: "Livestock Overview",
          detail:
            "Delve into the heart of Zoges Agro's animal kingdom, where our livestock flourishes in natural surroundings. Our farm is home to a range of animals, from free-ranging poultry to contented cows. Explore the diversity that defines our livestock and sets the stage for quality meat and dairy production.",
        },
        {
          name: "Ethical Practices",
          detail:
            "Zoges Agro stands firm in its commitment to ethical and humane animal husbandry. Our animals enjoy spacious living conditions, access to natural grazing, and a stress-free environment. We believe that happy animals result in superior products, and we uphold the highest standards of ethical practices.",
        },
        {
          name: "Product Range",
          detail:
            "Indulge your senses with Zoges Agro's premium range of meat and dairy products. From farm-fresh eggs to succulent cuts of meat, each product reflects our dedication to quality and the pure, wholesome goodness that defines our brand.",
        },
      ],
    },
    {
      name: "Trucking and Warehouse Services",
      photos:
        "https://onedrive.live.com/embed?resid=B8295C03D418D49B%21843&authkey=%21AJcBoVY1fouSaL8&width=612&height=458",
      subservice: [
        {
          name: "Transportation Services",
          detail:
            "Zoges Agro and Trucking Ventures seamlessly bridges the gap between our farm and your destination. Our dedicated trucking division ensures the safe and efficient transportation of our farm produce.",
        },
        {
          name: "",
          detail:
            "Count on us for reliable logistics that keep your orders on the move. ",
        },
        {
          name: "Warehouse Facilities",
          detail:
            "In addition to transportation, Zoges Agro offers state-of-the-art warehouse facilities. Our warehouses are equipped to handle the storage and preservation of farm produce, ensuring that your orders are not only transported with care but also stored in optimal conditions until they reach their final destination.",
        },
        {
          name: "Coverage Area",
          detail:
            "Discover the reach of Zoges Agro as we proudly serve a wide range of regions and markets. From local communities to distant wholesalers, our trucking division extends its reach to bring the freshness of Zoges to your doorstep. ",
        },
        {
          name: "Freshness Guarantee",
          detail:
            "Zoges Agro and Trucking Ventures is committed to delivering freshness beyond expectation. Our guarantee is more than a promise; it's a commitment to ensuring that our produce arrives at wholesalers and markets with the same crispness and flavor as the moment it left our fields. ",
        },
      ],
    },
  ],
  gallery: [
    'https://onedrive.live.com/embed?resid=B8295C03D418D49B%21840&authkey=%21AE67XS5Pu1lkSMs&width=612&height=408',
    'https://onedrive.live.com/embed?resid=B8295C03D418D49B%21816&authkey=%21AB4m4oQwq_ev660&width=3692&height=2848',
    'https://onedrive.live.com/embed?resid=B8295C03D418D49B%21832&authkey=%21AObAWsRY-PTIWgQ&width=3692&height=2848',
    'https://onedrive.live.com/embed?resid=B8295C03D418D49B%21846&authkey=%21AEkSiyZkQ8-yM4A&width=276&height=183'
  ]
};
